'use strict';

var Consts = require('consts');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var Strings = require('utils/strings');
var UserConfig = require('models/configurations');

var AppState = {
    layout: undefined,
    user: undefined,
    style: undefined,
    route: undefined,
    message: undefined,
    version: undefined,

    isSubdomain: false,
    isFullScreen: false,
    menuIsExpanded: true,

    URLParameterCache: {},

    featureBBoxMapReload: false,

    openIDProvider: [],
};

var deviceRegistry = {
    devices: {},
    smartTempInfo: {},
};

var defaultColumnList = [
    { id: '#_name', name: 'Name', alwaysVisible: true }, // i18n.TR('Name')
];

var keyChartsForDevice = function (deviceId) {
    return 'charts_for_' + deviceId;
};

var keyChartsForCategory = function (category) {
    return 'charts' + (category ? '_' + category : '');
};

var keyMeterValuesForDevice = function (deviceId) {
    return 'mtr_val_4_' + deviceId;
};

var getCategoryConfig = function (category) {
    var config = AppState.user.get('config') || {};
    return config[category] || {};
};

var saveUserConfig = function (configParams) {
    var config = new UserConfig(configParams);
    config.save(
        {},
        {
            parse: false,
            validate: false,
            error: function (model, response, options) {
                Notification.show(
                    'warning',
                    i18n.TR('Warnung'),
                    i18n.TR('Einstellungen konnten nicht gespeichert werden.')
                );
            },
        }
    );
};

AppState.getUserLanguage = function () {
    return AppState.user.get('lang');
};

AppState.isDeviceRanking = function () {
    return !AppState.user ? false : AppState.user.get('features').device_ranking;
};

AppState.availableColumnData = function (id) {
    return AppState.Cache.columnMap[id];
};

AppState.canLabelPool = function () {
    return !!(AppState.user.get('features') || {}).label_pool;
};

AppState.availableColumnDataByKey = function (key, categories) {
    var vi = Misc.splitAlarmValueKey(key);
    var fields = this.availableFields(categories, undefined, undefined);

    // locate by full match
    var match = Misc.selectWhere(fields, function (v) {
        return v.id == vi.id && (v.unit || '') == (vi.unit || '') && (v.name == vi.name || vi.name === undefined);
    });
    if (match.length) {
        return match[0];
    }

    // locate by id+unit match
    match = Misc.selectWhere(fields, function (v) {
        return v.id == vi.id && (v.unit == vi.unit || vi.unit === undefined);
    });
    if (match.length) {
        return match[0];
    }

    // locate by id match
    match = Misc.selectWhere(fields, function (v) {
        return v.id == vi.id;
    });
    return match[0];
};

AppState.requireColumns = function (fct) {
    AppState.Cache.require({ columns: true, columnMap: true }, function () {
        if (fct) {
            fct();
        }
    });
};

AppState.requireAllCapabilities = function (fct) {
    AppState.Cache.require({ allCapabilities: true }, function () {
        if (fct) {
            fct();
        }
    });
};

AppState.requireCompanyFeatures = function (fct) {
    AppState.Cache.require({ companyFeatures: true }, function () {
        if (fct) {
            fct();
        }
    });
};

AppState.uniqueFields = function (category, fieldGroup, fieldMode) {
    var fields = AppState.availableFields(category, fieldGroup, fieldMode);

    var fieldMap = {};
    var resultFields = [];

    _.each(fields, function (fld) {
        var fieldName = i18n.DATAPOINT(category, fld.name);
        if (fieldMap[fld.id]) {
            fieldMap[fld.id].names.push(fieldName);
        } else {
            fieldMap[fld.id] = { idx: resultFields.length, names: [fieldName] };
            resultFields.push(Misc.cloneAsJSON(fld));
        }
    });

    _.each(resultFields, function (fld) {
        var names = _.unique(fieldMap[fld.id].names);
        names.sort();
        fld.name = names.join(' / ');
    });
    return resultFields;
};

AppState.getValueUnitByKey = function (fieldKey, categories, value, fixedUnit) {
    var fieldData = AppState.availableColumnDataByKey(fieldKey, categories);
    if (!fieldData || !fieldData.type || !fieldData.format) return value;

    var valueUnit = Misc.getValueDisplayInfos(
        value,
        fieldData.type,
        fieldData.format,
        fieldData.unit,
        fixedUnit || fieldData.display_unit,
        !!fixedUnit || fieldData.is_unit_fixed
    );

    return valueUnit;
};

AppState.getValueUnit = function (field, value, fixedUnit) {
    var fieldData = AppState.availableColumnData(field) || {};
    if (!fieldData.type || !fieldData.format) return value;

    var valueUnit = Misc.getValueDisplayInfos(
        value,
        fieldData.type,
        fieldData.format,
        fieldData.unit,
        fixedUnit || fieldData.display_unit,
        !!fixedUnit || fieldData.is_unit_fixed
    );

    return valueUnit;
};

AppState.getValueText = function (field, value) {
    var valueUnit = AppState.getValueUnit(field, value);
    if (!valueUnit) return value;
    if (valueUnit.value === undefined) return value;

    return valueUnit.value + (valueUnit.unit ? ' ' + valueUnit.unit : '');
};

AppState.canEnumFieldValues = function (field) {
    var fieldData = AppState.availableColumnData(field) || {};
    return (
        fieldData.fieldGroup == Consts.FieldGroup.Device &&
        Consts.FieldInfo.Date.indexOf(field) == -1 &&
        Consts.FieldInfo.Numeric.indexOf(field) == -1
    );
};

AppState.availableFields = function (category, fieldGroup, fieldMode) {
    // filter columns
    return Misc.selectWhere(
        AppState.Cache.columns,
        function (x) {
            if (
                (category !== undefined &&
                    x.categories.indexOf(category) == -1 &&
                    (!x.categories.length || x.categories[0] != '*') &&
                    _.intersection(x.categories, category).length == 0) ||
                (fieldGroup !== undefined && x.fieldGroup != fieldGroup)
            )
                return false;

            var noList = fieldMode == 'user-group' ? Consts.FieldInfo.NoUserGroup : Consts.FieldInfo.NoColumn;
            return noList.indexOf(x.id) < 0;
        },
        function (item) {
            if (category) {
                var it2 = Misc.cloneAsJSON(item);
                it2.name = Misc.getFieldName(it2, category);
                return it2;
            }

            return item;
        }
    );
};

AppState.getAllCapabilities = function () {
    return AppState.Cache.allCapabilities;
};

AppState.availableColumns = function (category) {
    return AppState.availableFields(category, Consts.FieldGroup.Data);
};

AppState.uniqueColumns = function (category) {
    return AppState.uniqueFields(category, Consts.FieldGroup.Data);
};

AppState.getAvailableCategoryCount = function () {
    return this.user.get('available').device_categories || {};
};

AppState.availableDeviceGroups = function () {
    return this.user.get('available').device_groups || {};
};

AppState.isRestricted = function () {
    return this.user.get('restricted');
};

AppState.selectedColumns = function (category) {
    // initialize defaults
    var filterDefaults = [];
    if (!category || category == 'filter') {
        category = 'filter';
        filterDefaults = [
            { id: '#_category', name: 'Gerät' }, // i18n.TR('Gerät')
            { id: '#_type', name: 'Type' }, // i18n.TR('Gerätetyp')
        ];
    }

    // determine current configuration
    var columnsConfig = getCategoryConfig(category).columns;
    var updated = false;
    var available = AppState.uniqueFields(category, Consts.FieldGroup.Data);

    _.each(columnsConfig, function (c) {
        var pos = _.findIndex(available, function (a) {
            return a.id == c.id;
        });
        if (pos != -1 && c.name != available[pos].name) {
            c.name = available[pos].name;
            updated = true;
        }
    });

    if (updated) {
        var userConfig = AppState.user.get('config') || {};
        var categoryConfig = userConfig[category] || {};

        categoryConfig.columns = columnsConfig;

        userConfig[category] = categoryConfig;
        AppState.user.set('config', userConfig);

        AppState.saveSelectedColumns(category);
    }

    return defaultColumnList.concat(columnsConfig || filterDefaults);
};

AppState.isColumnFixed = function (item) {
    return (
        _.where(defaultColumnList, {
            id: '#_' + item.id,
            alwaysVisible: true,
        }).length > 0
    );
};

AppState.selectMeterValues = function (deviceId) {
    var key = keyMeterValuesForDevice(deviceId);
    return getCategoryConfig(key).meter_values;
};

AppState.isCustomChartSelection = function (deviceId) {
    var key = keyChartsForDevice(deviceId);
    var deviceConfig = getCategoryConfig(key);
    return deviceConfig && deviceConfig.charts && !deviceConfig.charts.invalid;
};

AppState.getChartShowEventsFromURL = function () {
    return AppState.getURLParameter(['show_events'], true).show_events == 'true';
};

AppState.getChartPeriodFromURL = function () {
    var periodContent = AppState.getURLParameter(['chart_period'], true);
    if (!periodContent || !periodContent.chart_period) return undefined;
    try {
        return JSON.parse(periodContent.chart_period);
    } catch (e) {
        return undefined;
    }
};

AppState.getChartContentFromURL = function () {
    // attempt to get it from the URL
    var chartContent = AppState.getURLParameter(['chart_content'], true);
    try {
        chartContent = (chartContent || {}).chart_content;
        chartContent = JSON.parse(chartContent);
    } catch (e) {
        chartContent = undefined;
    }
    return chartContent;
};

AppState.selectedCharts = function (deviceId, category) {
    var fixDeviceID = function (id) {
        var r = parseInt(id);
        return isNaN(r) ? undefined : r;
    };

    var processChartData = function (charts) {
        _.each(charts.lines, function (line) {
            line.device = fixDeviceID(line.device);
            line.device2 = fixDeviceID(line.device2);
        });

        return charts;
    };

    var chartContent = AppState.getChartContentFromURL();
    if (chartContent) {
        return processChartData(chartContent);
    }

    var deviceConfig = getCategoryConfig(keyChartsForDevice(deviceId));
    if (deviceConfig && deviceConfig.charts && !deviceConfig.charts.invalid)
        return processChartData(deviceConfig.charts);

    return processChartData(getCategoryConfig(keyChartsForCategory(category)).charts || {});
};

AppState.setSelectedColumns = function (category, columns) {
    var config = this.user.get('config') || {};
    var categoryConfig = config[category] || {};

    categoryConfig.columns = columns;
    config[category] = categoryConfig;

    this.user.set('config', config);
};

AppState.saveSelectedSeriesToURL = function (state) {
    var urlContent = {
        show_events: state.showEvents,
        chart_period: JSON.stringify(
            state && state.period && state.period.from && state.period.till
                ? { from: (60 * state.period.from.getTime()) / 60000, till: (60 * state.period.till.getTime()) / 60000 }
                : undefined
        ),
        chart_content: JSON.stringify(state.content),
    };

    if (state.url && state.url.startsWith('#')) state.url = state.url.substr(1);

    return AppState.setURLParameter(urlContent, 'update', state.url, true);
};

AppState.saveSelectedSeries = function (state, onlyThisDevice, deviceId, category) {
    // put chart settings into the URL
    var selection = state.content;
    AppState.saveSelectedSeriesToURL(state);
    var keyChart = keyChartsForDevice(deviceId);
    var key = onlyThisDevice ? keyChart : keyChartsForCategory(category);

    saveUserConfig({ id: key, charts: selection });

    var mainCfg = this.user.get('config');
    if (mainCfg) {
        mainCfg[key] = { charts: selection };
    }

    // clear old custom configuration (if available)
    if (!onlyThisDevice && getCategoryConfig(keyChart)) {
        var oldConfig = new UserConfig({
            id: keyChart,
            charts: { invalid: true },
        });
        oldConfig.save(
            {},
            {
                parse: false,
                validate: false,
            }
        );
    }
};

AppState.getItemsPerPage = function () {
    var mainCfg = this.user.get('config');
    if (!mainCfg || !mainCfg.tables) return 10;
    return mainCfg.tables.items_per_page || 10;
};

AppState.getStatsConfig = function () {
    var mainCfg = this.user.get('config');
    if (!mainCfg || !mainCfg.statistics) return {};
    var txt = mainCfg.statistics.configuration || '{}';
    return JSON.parse(txt);
};

AppState.saveStatsConfig = function (config) {
    saveUserConfig({
        id: 'statistics',
        configuration: JSON.stringify(config),
    });
};

AppState.saveItemsPerPage = function (itemsPerPage) {
    saveUserConfig({
        id: 'tables',
        items_per_page: parseInt(itemsPerPage),
    });

    var mainCfg = this.user.get('config');
    if (mainCfg && mainCfg.tables) mainCfg.tables.items_per_page = itemsPerPage;
};

AppState.saveInfoConfig = function (config) {
    saveUserConfig({
        id: 'info',
        preferences: config,
    });
};

AppState.saveSelectedColumns = function (category) {
    saveUserConfig({
        id: category,
        columns: getCategoryConfig(category).columns || [],
    });
};

AppState.saveSelectedMeterValues = function (deviceId, values) {
    saveUserConfig({
        id: keyMeterValuesForDevice(deviceId),
        meter_values: values,
    });
};

AppState.saveGatewayReportColumns = function (columns) {
    saveUserConfig({
        id: 'gateway_report',
        report_columns: columns,
    });
};

AppState.saveMapConfig = function (config) {
    saveUserConfig({
        id: 'map',
        filter: JSON.stringify(config),
    });
};

AppState.getMapConfig = function () {
    var defaultCfgString = '{"category": ["Gateway", "Gateway-RF", "FakeGateway"]}';
    var defaultCfg = JSON.parse(defaultCfgString);

    var mainCfg = this.user.get('config');
    if (!mainCfg || !mainCfg.map) {
        return defaultCfg;
    }

    var filterAsString = mainCfg.map.filter || defaultCfgString;
    return JSON.parse(filterAsString);
};

AppState.getRawConfiguration = function (category) {
    return Misc.deferredFct(function (defer) {
        var App = require('app');
        App.ajax({
            method: 'GET',
            url: '/api/v1/me/config/' + category,
            success: function (data) {
                if (data === '') {
                    defer.resolve(undefined);
                    return;
                }
                defer.resolve(JSON.parse(data));
            },
            error: function () {
                defer.resolve(undefined);
            },
        });
    });
};

AppState.hasCompanyUserPermission = function () {
    return AppState.hasCompanyPermission(Consts.PermissionsCompany.ManageUsers);
};

AppState.hasCompanyPermission = function (required) {
    var permissions = AppState.user.attributes.permissions || [];
    for (var i = 0; i < permissions.length; ++i) {
        if (permissions[i] == required) {
            return true;
        }
    }
    return false;
};

// returns true, if user has at least one of the following permissions:
//  - add devices
//  - remove devices
//  - view devices
AppState.hasCompanyDevicePermission = function () {
    return (
        AppState.hasCompanyPermission(Consts.PermissionsCompany.AddDevices) ||
        AppState.hasCompanyPermission(Consts.PermissionsCompany.RemoveDevices) ||
        AppState.hasCompanyPermission(Consts.PermissionsCompany.ViewDevices)
    );
};

// returns undefined, true or false if user has no permission, readonly or full permission
AppState.hasDevicePermission = function (required, ownPermissions) {
    var result = undefined;
    _.each(ownPermissions, function (value, perm) {
        if (perm == required) {
            result = value;
        }
    });
    return result;
};

AppState.registerDevices = function (devices) {
    var Devices = require('models/devices');

    _.each(devices, function (deviceItem) {
        deviceRegistry.devices[deviceItem.id] = {
            id: deviceItem.id,
            name: deviceItem.name,
            category: deviceItem.category,
            status:
                deviceItem.status ||
                (deviceRegistry.devices[deviceItem.id] && deviceRegistry.devices[deviceItem.id].status),
            station: deviceItem.station,
            location: !deviceItem.location
                ? deviceRegistry.devices[deviceItem.id] && deviceRegistry.devices[deviceItem.id].location // try existing location
                : JSON.parse(deviceItem.location),
            isEthernetController: Devices.IsEthernetController(deviceItem),
        };
    });
};

AppState.isDeviceRegistered = function (id) {
    return deviceRegistry.devices[id] && true;
};

AppState.getDeviceInfo = function (id) {
    return deviceRegistry.devices[id] || {};
};

AppState.destroyUser = function () {
    AppState.user = undefined;
    AppState.features = undefined;

    deviceRegistry = { devices: {} };
};

AppState.initUser = function (user) {
    if (!user) return;

    AppState.user = user;

    _.each(user.get('available').devices, function (list, cat) {
        _.each(list, function (d) {
            deviceRegistry.devices[parseInt(d.id)] = { id: d.id, name: d.name, category: cat };
        });
    });

    // adapt language
    var languageChanged = i18n.setLanguage(user.get('lang'));
    $.when(languageChanged).done(function () {
        var App = require('app');
        App.reInitialize();
    });
};

var getFieldGroup = function (col) {
    if (col.field_type == 3) return col.field_type;
    if (col.field_type === 1 && (col.id.startsWith('addr_') || col.id.startsWith('ctct_'))) return 2;
    return col.field_type;
};

AppState.initializeDataCache = function (requestFct, deleteStorage) {
    AppState.Cache = Misc.createCache(
        {
            allCapabilities: function (setter) {
                $.when(requestFct('device:capabilities')).done(function (list) {
                    list = list ? list.toJSON() : {};
                    setter(list);
                });
            },
            columnMap: function (setter) {
                AppState.Cache.require({ columns: true }, function () {
                    var colMap = {};
                    var names = {};
                    _.each(AppState.Cache.columns, function (col) {
                        colMap[col.id] = Misc.cloneAsJSON(col);
                        names[col.id] = names[col.id] || [];
                        names[col.id].push(i18n.DATAPOINT_BY_CATEGORIES(col.categories, col.name));
                    });

                    _.each(colMap, function (item) {
                        var colNames = names[item.id];
                        colNames.sort();
                        item.name = colNames.join(' / ');
                    });

                    setter(colMap);
                });
            },
            columns: function (setter) {
                $.when(requestFct('device:columns')).done(function (cols) {
                    _.each(cols, function (col) {
                        var parts = (col.id || '').split('_');
                        col.fieldGroup = Misc.getFieldGroup(col);
                        col.isVirtual = Misc.isVirtual(col.id);
                        col.isVirtualIntern = col.id.startsWith('VDD_');
                        col.dbName = col.name;
                        col.name = Misc.getFieldName(col);
                        col.type = parts.length == 2 ? parts[0] : undefined;
                    });
                    cols = Misc.selectWhere(cols, function (item) {
                        return item.name || item.field_type != 1;
                    });

                    _.each(cols, function (item) {
                        item.sortValue =
                            '' +
                            item.fieldGroup +
                            (Consts.FieldSortOrder[item.id] ? '0' : '1') +
                            (Consts.FieldSortOrder[item.id] || '') +
                            '-';
                    });
                    cols = _.sortBy(cols, function (item) {
                        return item.sortValue + item.name;
                    });
                    setter(cols);
                });
            },
            companyFeatures: function (setter) {
                $.when(requestFct('company:features')).done(function (features) {
                    setter(features);
                });
            },
        },
        { useLocalStorage: true, deleteLocalStorage: deleteStorage }
    );
};

AppState.filterToStr = function (filter) {
    return Misc.filterToStr(filter, AppState.Cache.columnMap, AppState.availableDeviceGroups());
};

// returns the 'wanted' entries from the URL request parameter list
AppState.getURLParameter = function (wanted, skipCache) {
    var url = Backbone.history.getFragment().split('?');
    var page = url[0];
    var urlParams = url.length > 1 ? Strings.splitURLparameter(url[1]) : {};
    var params = $.extend(urlParams, skipCache ? {} : this.URLParameterCache[page]);

    return wanted === undefined ? params : _.pick(params, wanted);
};

// reads parameters from current URL and saves them
AppState.saveURLParameter = function (params, page) {
    if (params) {
        this.URLParameterCache[page] = Misc.cleanObject(params) || {};
        return;
    }

    // no parameter in URL or parameter already given directly? -> return
    if (Backbone.history.fragment.indexOf('?') === -1) {
        this.URLParameterCache[Backbone.history.fragment] = {};
        return;
    }

    var url = Backbone.history.fragment.split('?');
    this.setURLParameter(Strings.splitURLparameter(url[1]), 'extend');
};

// reflects all parameters in the url. expects params to be a dictionary with string values
AppState.setURLParameter = function (params, updateMode, url, forceNoHistory) {
    var page = (url || Backbone.history.fragment).split('?')[0];
    switch (updateMode) {
        case 'replace':
            // throw away all old parameters and only use new ones
            break;
        case 'update':
            // extend existing parameters. In case of duplicates, keep new parameter
            params = _.extend(this.URLParameterCache[page] || {}, params);
            break;
        case 'extend':
            // extend existing parameters. In case of duplicates, keep old parameter
            params = _.extend(params, this.URLParameterCache[page] || {});
            break;
        default:
            throw 'you have to specify an updateMode!';
    }

    Misc.cleanObject(params);
    this.URLParameterCache[page] = params;

    // special case handling: remove attributes, which are already contained in the filter
    var self = this;
    if (this.URLParameterCache[page] && this.URLParameterCache[page]['filter']) {
        var filter = this.URLParameterCache[page]['filter'];
        filter = typeof filter === 'object' ? filter : JSON.parse(filter);
        _.each(filter, function (value, key) {
            delete self.URLParameterCache[page][key];
        });
    }

    // prepare browser URL containing state ..

    var relativeURL = Misc.removeQueryFromURL(url || Backbone.history.fragment);
    var prefix = '?';

    // .. append parameters to URL
    _.each(this.URLParameterCache[page], function (value, key) {
        relativeURL += prefix + key + '=' + encodeURIComponent(value);
        prefix = '&';
    });

    // adapt browser history
    if (
        !AppState.route ||
        Misc.removeQueryFromURL(AppState.route) != Misc.removeQueryFromURL(relativeURL) ||
        forceNoHistory
    ) {
        history.pushState({}, document.title, '#' + relativeURL);
        AppState.route = relativeURL;
    } else {
        history.replaceState({}, document.title, '#' + relativeURL);
    }

    return relativeURL;
};

AppState.clearURLParameterCache = function () {
    this.URLParameterCache = {};
};

AppState.showLockIcon = function (deviceID) {
    return (
        AppState.deviceIsLocked(deviceID) &&
        (AppState.hasCompanyPermission(Consts.PermissionsCompany.AddDevices) ||
            AppState.hasCompanyPermission(Consts.PermissionsCompany.RemoveDevices))
    );
};

AppState.deviceIsLocked = function (deviceID) {
    var ls = AppState.lockedDevices[deviceID];
    return ls && ls.locked;
};

AppState.deviceIsLockedForUser = function (deviceID) {
    var ls = AppState.lockedDevices[deviceID];
    // device is not locked at all
    if (!ls) return false;

    return AppState.deviceIsLocked(deviceID) && ls.user_id != AppState.user.id;
};

AppState.canUnlockDevice = function (deviceID) {
    var ls = AppState.lockedDevices[deviceID];
    // device is not locked -> "can unlock"
    if (!ls) return true;

    return ls.user_id === AppState.user.id && ls.device_id === ls.root_device_id;
};

AppState.setDeviceLockStatus = function (devLock) {
    // device unlocked? -> delete entry
    if (!devLock.child_locked && !devLock.locked) {
        delete AppState.lockedDevices[devLock.device_id];
    } else {
        AppState.lockedDevices[devLock.device_id] = devLock;
    }
};

AppState.getQuickLinks = function (device, permissions) {
    var links = [];
    Consts.QuickMenuRoutes.forEach(function (route) {
        if (route.permission == 0 || AppState.hasDevicePermission(route.permission, permissions) != undefined) {
            if (!route.categories || route.categories.includes(device.get('category'))) {
                links.push({
                    link: Consts.DeviceCategory[device.get('category')].url + '/' + device.id + '/' + route.url,
                    name: route.name,
                    icon: route.icon,
                });
            }
        }
    });
    return links;
};

AppState.isUserManagementAdmin = function () {
    return (AppState.user.get('permissions') || []).includes(Consts.PermissionsCompany.ManageUsers);
};

AppState.getContractNrList = function () {
    return AppState.user.get('contract_nr_list') || [];
};

AppState.isUserAdmin = function () {
    if (AppState.user.get('is_admin')) {
        return true;
    }

    var p = AppState.user.get('permissions');
    return p.length > 0;
};

AppState.dashboardAvailable = function () {
    if (!AppState.user) {
        return false;
    }

    var dashboardConfig = AppState.user.get('features').dashboard;
    if (!dashboardConfig) {
        return false;
    }

    return dashboardConfig.allowed_user !== 'super_admin' || AppState.user.get('is_admin');
};

module.exports = AppState;
